import React from 'react';
import '../PlanHero/styles.css';
import Typography from '@mui/material/Typography';
import { ReactComponent as IconoColumba } from '../../../assets/Svg/IconoColumba.svg';
import ItacaWideBlack from '../../../assets/fonts/itaca/Itaca Wide Black.ttf';
import ItacaWideBold  from '../../../assets/fonts/itaca/Itaca-Wide-Bold.otf';
import ItacaWideDemiBold from '../../../assets/fonts/itaca/Itaca-Wide-DemiBold.otf';
import AlbertSansRegular from '../../../assets/fonts/Albert_Sans/AlbertSans-Regular.ttf';
import TodoDataService from '../../../hooks/services'


// Inyecta todas las fuentes directamente
const fontStyles = `
@font-face {
  font-family: Itaca-Wide-Black, sans-serif !important;
  src: url(${ItacaWideBlack}) format('truetype');
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Itaca-Wide-Bold';
  src: url(${ItacaWideBold}) format('opentype');
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Itaca-Wide-DemiBold';
  src: url(${ItacaWideDemiBold}) format('opentype');
  font-style: normal;
  font-display: swap;
}

  @font-face {
  font-family: 'Albert-Sans-Regular';
  src: url(${AlbertSansRegular}) format('opentype');
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}
/* Agrega más @font-face para otras variantes si es necesario */
`;

// Crea y añade el elemento style al head
const styleElement = document.createElement('style');
styleElement.innerHTML = fontStyles;
document.head.appendChild(styleElement);

const PlanHero = () => {
  // Función para redireccionar a WhatsApp
  const redirectToWhatsApp = () => {
    const phoneNumber = '+527227842615';
    const message = encodeURIComponent('Visite su página web; estoy interesado en sus servicios.');
    window.open(`https://wa.me/${TodoDataService.GetNumberCall2()}?text=${message}`, '_blank');
  };

  // Función reutilizable para Typography con soporte para responsive
  const renderText = (text, options = {}) => (
    <Typography
      component={options.component || 'p'} // etiqueta HTML que deseas: 'p', 'h1', 'div', etc.  
      color={options.color || '#FFFFFF'}
      fontSize={options.fontSize}
      fontFamily={options.fontFamily}
      display={options.display || 'inline'}
      fontWeight={options.fontWeight}
      lineHeight={options.lineHeight || '100%'}
      sx={{
        '@media (max-width: 480px)': {
          fontSize: options.mobileFontSize
        },
        ...options.sx
      }}
      {...options}
    >
      {text}
    </Typography>
  );

  return (
    <section className="plan-hero">
      <div className="hero-overlay" aria-hidden="true"></div>
      <div className="hero-content-container">
        <div className="hero-content" >
          <div style={{display:'flex'}}>
             <h1 className="title-bg itacaBlack">
            {renderText("Planes funerarios a futuro en Toluca", {
              component: 'h1',
              color: '#FFFFFF',
              fontSize: '16px',
              mobileFontSize: '12px !important',
              fontFamily: "itacaBlack, sans-serif !important",
              //fontWeight: 700 
            })}
          </h1>
          </div>
         
          <h2>
            {renderText("Tranquilidad que comienza hoy.", {
              component: 'h2',
              color: '#FFFFFF',
              fontSize: '36px',
              mobileFontSize: '30px !important',
              fontFamily: "'Itaca-Wide-Bold', sans-serif !important"
            })}
          </h2>
          
          <p className='ParrafoInline'>
            {renderText("En la vida, hay decisiones que nos dan paz. Una de ellas es", {
              component: 'p',
              fontFamily: "'Albert-Sans-Regular', sans-serif !important",
              fontSize: '18px',
              mobileFontSize: '16px !important'
            })}
          </p>
          <p className='ParrafoInline AlbertBold'>
            {renderText(" anticiparse a lo inevitable y dejarlo todo resuelto", {
              component: 'p',
              fontFamily: "'AlbertBold', sans-serif !important",
              fontSize: '18px',
              mobileFontSize: '16px !important'
            })}
          </p>
          <p className='ParrafoInline'>
            {renderText(" para no dejar preocupaciones a quienes más queremos.", {
              component: 'p',
              fontFamily: "'Albert-Sans-Regular', sans-serif !important",
              fontSize: '18px',
              mobileFontSize: '16px !important'
            })}
          </p>
          <button 
            className="cta-button MT-25" 
            aria-label="Comprar planes funerarios ahora"
            onClick={redirectToWhatsApp}
          >
            {renderText("Compra ahora", {
              color: '#000000',
              fontFamily: "'Itaca-Wide-DemiBold', sans-serif !important",
              fontSize: '18px',
              lineHeight: '24px',
              mobileFontSize: '18px !important'
            })}
            <IconoColumba style={{ marginLeft: 8 }} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default React.memo(PlanHero);